import operationalStatuses from './operationalStatuses';

function tripStatuses(status) {
	return operationalStatuses(status);
}

tripStatuses.cancelled = operationalStatuses.cancelled;
tripStatuses.draft = operationalStatuses.draft;
tripStatuses.ready = operationalStatuses.ready;

export default tripStatuses;